import { ThemeConfig } from "antd";

export const ANTD_THEME: ThemeConfig = {
  token: {
    colorPrimary: "var(--primary-color)",
    colorTextBase: "var(--text-color)",
    colorBgContainer: "var(--bg-color)",
    colorBorder: "var(--border-color)",

    fontSizeSM: 12,
    fontSize: 14,
    fontSizeLG: 16,
    fontSizeXL: 20,

    borderRadiusSM: 4,
    borderRadius: 8,
    borderRadiusLG: 16,

    boxShadow: "var(--shadow-sm)",
    boxShadowSecondary: "var(--shadow-md)",
    boxShadowTertiary: "var(--shadow-lg)",
  },
  components: {
    Button: {
      colorPrimary: "var(--primary-color)",
      colorText: "var(--text-color)",
      colorBgContainer: "var(--bg-color)",
      colorBorder: "var(--border-color)",
    },
  },
};
